const HubSpotUsersLink = () => import('@/views/account/integrations/hubspot/import/hubspot-users-link-view.vue');
const HubSpotCompaniesImport = () => import('@/views/account/integrations/hubspot/import/hubspot-companies-import-view.vue');
const HubSpotContactsImport = () => import('@/views/account/integrations/hubspot/import/hubspot-contacts-import-view');
const HubSpotActivitiesImport = () => import('@/views/account/integrations/hubspot/import/hubspot-activities-import-view');
const HubSpotOpportunitiesImport = () => import('@/views/account/integrations/hubspot/import/hubspot-opportunities-import-view');

import store from '@/stores/index';

export default [
    {
        path: '/Integrations/HubSpot/Manage/Users/Link',
        name: 'HubSpotUsersLink',
        component: HubSpotUsersLink,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HubSpot/Manage/Users/Link',
        name: 'ClientHubSpotUsersLink',
        component: HubSpotUsersLink,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/HubSpot/Manage/Companies/Import',
        name: 'HubSpotCompaniesImport',
        component: HubSpotCompaniesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HubSpot/Manage/Companies/Import',
        name: 'ClientHubSpotCompaniesImport',
        component: HubSpotCompaniesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/HubSpot/Manage/Contacts/Import',
        name: 'HubSpotContactsImport',
        component: HubSpotContactsImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HubSpot/Manage/Contacts/Import',
        name: 'ClientHubSpotContactsImport',
        component: HubSpotContactsImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/HubSpot/Manage/Activities/Import',
        name: 'HubSpotActivitiesImport',
        component: HubSpotActivitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HubSpot/Manage/Activities/Import',
        name: 'ClientHubSpotActivitiesImport',
        component: HubSpotActivitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    },
    {
        path: '/Integrations/HubSpot/Manage/Opportunities/Import',
        name: 'HubSpotOpportunitiesImport',
        component: HubSpotOpportunitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        },
        beforeEnter: (to, from, next) => {
            if (!store.getters.isAdmin) {
                next('/Unauthorized');
            } else {
                next();
            }
        }
    },
    {
        path: '/Clients/:clientId/Integrations/HubSpot/Manage/Opportunities/Import',
        name: 'ClientHubSpotOpportunitiesImport',
        component: HubSpotOpportunitiesImport,
        props: true,
        meta: {
            isUiShown: true,
            subtype: 'account',
            pageClass: 'integration-settings-page'
        }
    }
]